import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { LoggingService } from './logging.service';
import { ApiService } from './api.service';
import { UserProfile } from '../models/userProfile';
import { Role } from '../models/role';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(
    private httpClient: HttpClient,
    private apiService: ApiService,
    private loggingService: LoggingService
  ) { }

  /**
   * Get user profile by userId
   */
  getProfile(userId: number): Observable<UserProfile> {
    this.loggingService.logDebug(`Fetching profile for userId: ${userId}`);
    return this.httpClient.get<UserProfile>(
      this.apiService.getUrl(`user-profile/${userId}`)
    );
  }

  /**
   * Create or Update profile (same endpoint)
   */
  saveProfile(dto: UserProfile): Observable<any> {
    this.loggingService.logDebug(`Saving profile for userId: ${dto.userId}`);
    return this.httpClient.post(
      this.apiService.getUrl('user-profile'),
      dto
    );
  }

  getAllRole(): Observable<Role[]> {
    return this.httpClient.get<Role[]>(
      this.apiService.getUrl('role')
    ).pipe(
      tap((data) => {
        this.loggingService.logDebug(`Successfully received ${data.length} roles`);
      }),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  getRoleById(roleId: number): Observable<Role> {
    return this.httpClient.get<Role>(this.apiService.getUrl(`role/${roleId}`));
  }
}
